import { graphql, useFragment } from 'react-relay';

import { useRenderBlurbs_item$key } from './__generated__/useRenderBlurbs_item.graphql';
import { useRenderBlurbs_displayInfo$key } from './__generated__/useRenderBlurbs_displayInfo.graphql';

const itemFragment = graphql`
    fragment useRenderBlurbs_item on Item {
        isAuctionEnabled
        lastTransaction(buyerId: $userId) @include(if: $fetchUser) {
            checkoutDate
            isCanceled
            mostRecentOffer {
                isExpired
            }
        }
        relevantAuctionLot(page: pdp) @include(if: $fetchAuction) {
            status
        }
    }
`;

const displayInfoFragment = graphql`
    fragment useRenderBlurbs_displayInfo on ItemDisplayInfo {
        pricing {
            showSold
            showUnavailable
        }
    }
`;

export const useRenderBlurbs = ({
    item: itemRef,
    displayInfo: displayInfoRef,
}: {
    item: useRenderBlurbs_item$key | null | undefined;
    displayInfo: useRenderBlurbs_displayInfo$key | null | undefined;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const displayInfo = useFragment(displayInfoFragment, displayInfoRef);

    if (!item || !displayInfo) {
        return false;
    }

    const pricingDisplayInfo = displayInfo?.pricing || null;
    const hasValidPricingDisplayInfo = !!pricingDisplayInfo && !pricingDisplayInfo.showUnavailable;

    const { isAuctionEnabled, relevantAuctionLot, lastTransaction } = item;
    const { checkoutDate, isCanceled, mostRecentOffer } = lastTransaction || {};
    const shouldRenderBlurbsForAuction =
        relevantAuctionLot?.status === 'OPEN' ||
        !!(lastTransaction && !checkoutDate && !mostRecentOffer?.isExpired && !isCanceled);

    return (
        (!isAuctionEnabled && hasValidPricingDisplayInfo && !pricingDisplayInfo.showSold) ||
        shouldRenderBlurbsForAuction
    );
};
